export var giftMap = {
  jp: {
    title: '究極のEcoFlowユーザーのための究極の特典！',
    winnerList: '当選者リスト',
    desc: '*上記のキャンペーン対象者は、3月15日～4月3日のキャンペーン期間中に初めて会員登録いただいた方です。\n * キャンペーン期間中の早い段階で会員登録をするほど、当選率がアップします。\n * 4月7日にEFキャリーワゴンと新商品RIVER 2 Proの当選者リストを公開いたします。EFキャリーワゴンに当選されなかった方は、新商品RIVER 2 Proの抽選対象となります。',
    linkText: '注意事項についてはこちら',
    link: '',
    allNum: 25000,
    list: [{
      num: '登録者数1,000人突破',
      h5Num: '登録者1,000人突破',
      number: 1000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'EFキャリーワゴン（抽選で200名様）',
      src: ['gift1_jp.webp', 'gift1_jp.png'],
      activeTime: '2023-03-24 10:00:00',
      stepWidth: 200,
      allWidth: 200,
      widthPercent: 0.2,
      nextWidthPercent: 1 / 6,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.022,
      nextHeightPercent: 23 / 300
    }, {
      num: '登録者数2,500人突破',
      h5Num: '登録者2,500人突破',
      number: 2500,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: '新商品RIVER 2 Pro（抽選で5名様）',
      src: ['gift2_jp.webp', 'gift2_jp.png'],
      activeTime: '2023-03-30 15:00:00',
      stepWidth: 280,
      allWidth: 480,
      widthPercent: 14 / 75,
      nextWidthPercent: 0.2,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 23 / 300,
      nextHeightPercent: 0.022
    }]
  },
  kr: {
    title: '',
    winnerList: '당첨 리스트',
    desc: '*에코플로우 데이 이벤트 기간(3월17일-4월10일) 구매 고객에 해당\n *미스터리 박스 1 당첨자 대상 5%할인쿠폰 3월 20일 일괄 발송 예정\n *미스터리 박스2 및 미스터리 박스3의 당첨자 명단은 4월17일 공식 네이버 카페에서 공개 예정',
    h5Desc: '*에코플로우 데이 이벤트 기간(3월17일-4월10일) 구매\n 고객에 해당\n *미스터리 박스 1 당첨자 대상 5%할인쿠폰 3월 20일 일괄 발송 예정\n *미스터리 박스2 및 미스터리 박스3의 당첨자 명단은 \n4월17일 공식 네이버 카페에서 공개 예정',
    linkText: '',
    link: '',
    allNum: 30000,
    couponText: '당첨자 이메일로 5% 할인쿠폰을 보냈습니다. \n확인 부탁드립니다. 감사합니다.',
    list: [{
      num: '회원수 500명 돌파',
      h5Num: '회원수 500명\n돌파',
      number: 500,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: '한정 5% 할인 쿠폰\n(500명)',
      src: ['gift1_kr.webp', 'gift1_kr.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 95,
      allWidth: 95,
      widthPercent: 0.19,
      nextWidthPercent: 0.25,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.044,
      nextHeightPercent: 0.115,
      isCoupon: true
    }, {
      num: '회원수 1500명 돌파',
      number: 1500,
      bgColor: '#a65b81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: '한정 에코플로우 캠핑의자\n(50명)',
      src: ['gift2_kr.webp', 'gift2_kr.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 250,
      allWidth: 345,
      widthPercent: 0.25,
      nextWidthPercent: 47 / 300,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.115,
      nextHeightPercent: 23 / 300
    }, {
      num: '회원수 3000명 돌파',
      number: 3000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: '한정 리버 2(5명)',
      src: ['gift3_kr.webp', 'gift3_kr.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 235,
      allWidth: 580,
      widthPercent: 47 / 300,
      nextWidthPercent: 0.2,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 23 / 300,
      nextHeightPercent: 0.044
    }]
  },
  za: {
    title: '',
    winnerList: 'winners',
    desc: 'Winners will be announced once all milestones have been achieved. \nGift Box Challenge Terms & Conditions Ultimate Gift Box Challenge Terms & Conditions',
    linkText: 'More',
    link: '',
    allNum: 110000,
    list: [{
      num: '10,000',
      number: 10000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: '10% Off Coupon\n(25 Winners)',
      src: ['gift1_za.webp', 'gift1_za.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 65,
      allWidth: 65,
      widthPercent: 0.0065,
      nextWidthPercent: 0.023,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.0022,
      nextHeightPercent: 0.0115
    }, {
      num: '20,000',
      number: 20000,
      bgColor: '#805CA7',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'RIVER\n(15 Winners)',
      src: ['gift2_za.webp', 'gift2_za.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 230,
      allWidth: 295,
      widthPercent: 0.023,
      nextWidthPercent: 0.022,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0115
    }, {
      num: '30,000',
      number: 30000,
      bgColor: '#A65B81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'RIVER Max\n(10 Winners)',
      src: ['gift3_za.webp', 'gift2_za.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 220,
      allWidth: 515,
      widthPercent: 0.022,
      nextWidthPercent: 0.011,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0115
    }, {
      num: '50,000',
      number: 50000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'RIVER 2 Max\n(3 Winners)',
      src: ['gift4_za.webp', 'gift4_za.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 220,
      allWidth: 735,
      widthPercent: 0.011,
      nextWidthPercent: 0.02,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0022
    }]
  },
  au: {
    title: '',
    winnerList: 'winners',
    desc: 'Winners will be announced once all milestones have been achieved.',
    linkText: 'Gift Box Challenge Terms & Conditions',
    link: '',
    allNum: 65000,
    list: [{
      num: '5,000',
      number: 5000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: '10% Off Coupon\n(15 Winners)',
      src: ['gift1_au.webp', 'gift1_au.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 106,
      allWidth: 106,
      widthPercent: 0.0212,
      nextWidthPercent: 0.037,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.0044,
      nextHeightPercent: 0.023
    }, {
      num: '10,000',
      number: 10000,
      bgColor: '#805CA7',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'RIVER\n(10 Winners)',
      src: ['gift2_au.webp', 'gift2_au.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 185,
      allWidth: 291,
      widthPercent: 0.037,
      nextWidthPercent: 0.0166,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.023,
      nextHeightPercent: 0.0115
    }, {
      num: '20,000',
      number: 20000,
      bgColor: '#A65B81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'RIVER Max\n(5 Winners)',
      src: ['gift3_au.webp', 'gift2_au.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 166,
      allWidth: 457,
      widthPercent: 0.0166,
      nextWidthPercent: 0.01625,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0115
    }, {
      num: '30,000',
      number: 30000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'River 2 Max\n(3 Winners)',
      src: ['gift4_au.webp', 'gift4_au.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 165,
      allWidth: 622,
      widthPercent: 0.01625,
      nextWidthPercent: 0.02,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0044
    }]
  },
  uk: {
    title: '',
    winnerList: 'winners',
    desc: 'Rules: Winners will be selected each milestones, register / login now to win Ultimate Gift Box, Register now and get 500 EcoCredits immediately!',
    linkText: 'More',
    link: '',
    allNum: 55000,
    list: [{
      num: '5,000',
      number: 5000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'EcoFlow Camping Light\n(20 pcs)',
      src: ['gift1_eu.webp', 'gift1_eu.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 110,
      allWidth: 110,
      widthPercent: 0.022,
      nextWidthPercent: 0.046,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.0044,
      nextHeightPercent: 0.023
    }, {
      num: '10,000',
      number: 10000,
      bgColor: '#805CA7',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'EcoFlow Collapsible Wagon Cart\n(10 pcs)',
      src: ['gift2_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 230,
      allWidth: 340,
      widthPercent: 0.046,
      nextWidthPercent: 0.043,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.023,
      nextHeightPercent: 0.023
    }, {
      num: '15,000',
      number: 15000,
      bgColor: '#A65B81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Test a New Product\n(1 pc)',
      src: ['gift3_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 215,
      allWidth: 555,
      widthPercent: 0.043,
      nextWidthPercent: 0.0135,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 0.023,
      nextHeightPercent: 0.0115
    }, {
      num: '25,000',
      number: 25000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'DELTA Pro\n(1 pc)',
      src: ['gift4_eu.webp', 'gift4_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 135,
      allWidth: 690,
      widthPercent: 0.0135,
      nextWidthPercent: 0.02,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0044
    }]
  },
  de: {
    title: '',
    winnerList: 'Gewinnerliste',
    desc: 'Regeln: Die Gewinner werden an jedem Etappenziel ausgewählt. Registrieren Sie sich jetzt oder loggen Sie sich ein, um die ultimative Geschenkbox zu gewinnen. Registrieren Sie sich jetzt und erhalten Sie sofort 500 EcoCredits!',
    linkText: 'Mehr',
    link: '',
    allNum: 55000,
    list: [{
      num: '10.000',
      number: 10000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'EcoFlow Campinglicht\n(20 Stk.)',
      src: ['gift1_eu.webp', 'gift1_eu.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 55,
      allWidth: 55,
      widthPercent: 0.0055,
      nextWidthPercent: 0.026,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.0022,
      nextHeightPercent: 0.0115
    }, {
      num: '20.000',
      number: 20000,
      bgColor: '#a65b81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'EcoFlow Zusammenklappbarer Bollerwagen\n(10 Stk.)',
      src: ['gift2_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 260,
      allWidth: 315,
      widthPercent: 0.026,
      nextWidthPercent: 0.0285,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0115
    }, {
      num: '30.000',
      number: 30000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Testen Sie ein neues Produkt\n(1 Stk.)',
      src: ['gift3_eu.webp', 'gift3_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 285,
      allWidth: 600,
      widthPercent: 0.0285,
      nextWidthPercent: 0.018,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 0.0115,
      nextHeightPercent: 0.023
    }, {
      num: '40.000',
      number: 40000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'DELTA Pro\n(1 Stk.)',
      src: ['gift4_eu.webp', 'gift4_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 180,
      allWidth: 780,
      widthPercent: 0.018,
      nextWidthPercent: 0.05,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0022
    }]
  },
  fr: {
    title: '',
    winnerList: 'Liste des gagnants',
    desc: 'Règles : Les gagnants seront sélectionnés à chaque étape. Inscrivez-vous/connectez-vous maintenant pour gagner le coffret cadeau Ultimate. Inscrivez-vous maintenant et obtenez 500 EcoCredits immédiatement !',
    linkText: 'Plus',
    link: '',
    allNum: 55000,
    list: [{
      num: '10.000',
      number: 10000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'Lumière de camping EcoFlow\n(20 pcs)',
      src: ['gift1_eu.webp', 'gift1_eu.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 85,
      allWidth: 85,
      widthPercent: 0.0085,
      nextWidthPercent: 0.022,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.0022,
      nextHeightPercent: 0.0115
    }, {
      num: '20.000',
      number: 20000,
      bgColor: '#a65b81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Chariot pliable EcoFlow\n(10 pcs)',
      src: ['gift2_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 220,
      allWidth: 305,
      widthPercent: 0.022,
      nextWidthPercent: 0.021,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0115
    }, {
      num: '30.000',
      number: 30000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Tester un nouveau produit\n(1 pc)',
      src: ['gift3_eu.webp', 'gift3_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 210,
      allWidth: 515,
      widthPercent: 0.021,
      nextWidthPercent: 0.019,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 0.0115,
      nextHeightPercent: 0.023
    }, {
      num: '40.000',
      number: 40000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'DELTA Pro\n(1 pc)',
      src: ['gift4_eu.webp', 'gift4_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 190,
      allWidth: 705,
      widthPercent: 0.019,
      nextWidthPercent: 0.02,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0022
    }]
  },
  it: {
    title: '',
    winnerList: 'Lista dei vincitori',
    desc: 'Regolamento: I vincitori saranno selezionati a ciascun traguardo raggiunto, registrati/accedi ora per vincere il regalo perfetto, Registrati ora e ottieni subito 500 EcoCredit!',
    linkText: 'Altro',
    link: '',
    allNum: 55000,
    list: [{
      num: '2.000',
      number: 2000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'Lampada per campeggio EcoFlow\n(20 pcs)',
      src: ['gift1_eu.webp', 'gift1_eu.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 100,
      allWidth: 100,
      widthPercent: 0.05,
      nextWidthPercent: 1 / 12,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.011,
      nextHeightPercent: 23 / 600
    }, {
      num: '5.000',
      number: 5000,
      bgColor: '#a65b81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Carrello pieghevole EcoFlow\n(10 pcs)',
      src: ['gift2_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 250,
      allWidth: 350,
      widthPercent: 1 / 12,
      nextWidthPercent: 11 / 150,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 23 / 600,
      nextHeightPercent: 23 / 600
    }, {
      num: '8.000',
      number: 8000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Prova un nuovo prodotto\n(1 pc)',
      src: ['gift3_eu.webp', 'gift3_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 220,
      allWidth: 570,
      widthPercent: 11 / 150,
      nextWidthPercent: 0.09,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 23 / 600,
      nextHeightPercent: 0.0575
    }, {
      num: '10.000',
      number: 25000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'DELTA Pro\n(1 pc)',
      src: ['gift4_eu.webp', 'gift4_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 180,
      allWidth: 750,
      widthPercent: 0.09,
      nextWidthPercent: 0.05,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0575,
      nextHeightPercent: 0.011
    }]
  },
  es: {
    title: '',
    winnerList: 'Lista de ganadores',
    desc: 'Reglas: Los ganadores serán seleccionados cada vez que logren hitos. Regístrate/inicia sesión ahora para obtener el mejor cofre regalo. Regístrate ahora y consigue 500 EcoCredits inmediatamente.',
    linkText: 'Más información',
    link: '',
    allNum: 55000,
    list: [{
      num: '2.000',
      number: 2000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'Luz EcoFlow para acampada\n(20 pcs)',
      src: ['gift1_eu.webp', 'gift1_eu.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 80,
      allWidth: 80,
      widthPercent: 0.04,
      nextWidthPercent: 0.09,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.011,
      nextHeightPercent: 23 / 600
    }, {
      num: '5.000',
      number: 5000,
      bgColor: '#a65b81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Carrito de transporte plegable EcoFlow\n(10 pcs)',
      src: ['gift2_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 270,
      allWidth: 350,
      widthPercent: 0.09,
      nextWidthPercent: 53 / 600,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 23 / 600,
      nextHeightPercent: 23 / 600
    }, {
      num: '8.000',
      number: 8000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Probar un nuevo producto\n(1 pc)',
      src: ['gift3_eu.webp', 'gift3_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 265,
      allWidth: 615,
      widthPercent: 53 / 600,
      nextWidthPercent: 0.095,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 23 / 600,
      nextHeightPercent: 0.0575
    }, {
      num: '10.000',
      number: 10000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'DELTA Pro\n(1 pc)',
      src: ['gift4_eu.webp', 'gift4_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 190,
      allWidth: 805,
      widthPercent: 0.095,
      nextWidthPercent: 0.05,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0575,
      nextHeightPercent: 0.011
    }]
  },
  eu: {
    title: '',
    winnerList: 'winners',
    desc: 'Rules: Winners will be selected each milestones, register / login now to win Ultimate Gift Box, Register now and get 500 EcoCredits immediately!',
    linkText: 'More',
    link: '',
    allNum: 55000,
    list: [{
      num: '5,000',
      number: 5000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'EcoFlow Camping Light\n(20 pcs)',
      src: ['gift1_eu.webp', 'gift1_eu.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 105,
      allWidth: 105,
      widthPercent: 0.021,
      nextWidthPercent: 0.048,
      // 分割线，防止设置错
      stepHeight: 22,
      allHeight: 22,
      heightPercent: 0.0044,
      nextHeightPercent: 0.023
    }, {
      num: '10,000',
      number: 10000,
      bgColor: '#a65b81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'EcoFlow Collapsible Wagon Cart\n(10 pcs)',
      src: ['gift2_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 240,
      allWidth: 345,
      widthPercent: 0.048,
      nextWidthPercent: 0.045,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 137,
      heightPercent: 0.023,
      nextHeightPercent: 0.023
    }, {
      num: '15,000',
      number: 15000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Test a New Product\n(1 pc)',
      src: ['gift3_eu.webp', 'gift2_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 225,
      allWidth: 570,
      widthPercent: 0.045,
      nextWidthPercent: 0.0145,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 252,
      heightPercent: 0.023,
      nextHeightPercent: 0.023
    }, {
      num: '25,000',
      number: 25000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'DELTA Pro\n(1 pc)',
      src: ['gift4_eu.webp', 'gift4_eu.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 145,
      allWidth: 715,
      widthPercent: 0.0145,
      nextWidthPercent: 0.02,
      // 分割线，防止设置错
      stepHeight: 115,
      allHeight: 367,
      heightPercent: 0.0115,
      nextHeightPercent: 0.0044
    }]
  },
  us: {
    title: '',
    winnerList: 'winners',
    desc: '* Only open to all registered EcoFlow website ID users in the US and CA.\n** Winners will be announced once all milestones have been achieved.',
    linkText: 'Gift Box Challenge Terms & Conditions',
    link: '',
    allNum: 270000,
    list: [{
      num: '30,000',
      number: 30000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'OutDoor Kit',
      src: ['gift1_us.webp', 'gift1_us.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 55,
      allWidth: 55,
      widthPercent: 11 / 6000,
      nextWidthPercent: 1 / 150,
      // 分割线，防止设置错
      stepHeight: 17,
      allHeight: 17,
      heightPercent: 17 / 30000,
      nextHeightPercent: 0.0035
    }, {
      num: '60,000',
      number: 60000,
      bgColor: '#805CA7',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: '10% Off Coupon',
      src: ['gift2_us.webp', 'gift2_us.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 200,
      allWidth: 255,
      widthPercent: 1 / 150,
      nextWidthPercent: 0.00975,
      // 分割线，防止设置错
      stepHeight: 105,
      allHeight: 122,
      heightPercent: 0.0035,
      nextHeightPercent: 0.00525
    }, {
      num: '80,000',
      number: 80000,
      bgColor: '#A65B81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'River 2 Pro',
      src: ['gift3_us.webp', 'gift2_us.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 195,
      allWidth: 450,
      widthPercent: 0.00975,
      nextWidthPercent: 0.01125,
      // 分割线，防止设置错
      stepHeight: 105,
      allHeight: 227,
      heightPercent: 0.00525,
      nextHeightPercent: 0.00525
    }, {
      num: '100,000+',
      number: 100000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Whole-Home Starter Kit',
      src: ['gift4_us.webp', 'gift4_us.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 225,
      allWidth: 675,
      widthPercent: 0.01125,
      nextWidthPercent: 0.001,
      // 分割线，防止设置错
      stepHeight: 105,
      allHeight: 332,
      heightPercent: 0.00525,
      nextHeightPercent: 17 / 30000
    }]
  },
  ca: {
    title: '',
    winnerList: 'winners',
    desc: '* Only open to all registered EcoFlow website ID users in the US and CA.\n** Winners will be announced once all milestones have been achieved.',
    linkText: 'Gift Box Challenge Terms & Conditions',
    link: '',
    allNum: 270000,
    list: [{
      num: '30,000',
      number: 30000,
      bgColor: '#615DC6',
      border: '2px solid #ffa59a',
      productName: 'OutDoor Kit',
      src: ['gift1_us.webp', 'gift1_us.png'],
      activeTime: '2023-03-18 12:00:00',
      stepWidth: 55,
      allWidth: 55,
      widthPercent: 11 / 6000,
      nextWidthPercent: 1 / 150,
      // 分割线，防止设置错
      stepHeight: 17,
      allHeight: 17,
      heightPercent: 17 / 30000,
      nextHeightPercent: 0.0035
    }, {
      num: '60,000',
      number: 60000,
      bgColor: '#805CA7',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: '10% Off Coupon',
      src: ['gift2_us.webp', 'gift2_us.png'],
      activeTime: '2023-03-29 15:00:00',
      stepWidth: 200,
      allWidth: 255,
      widthPercent: 1 / 150,
      nextWidthPercent: 0.00975,
      // 分割线，防止设置错
      stepHeight: 105,
      allHeight: 122,
      heightPercent: 0.0035,
      nextHeightPercent: 0.00525
    }, {
      num: '80,000',
      number: 80000,
      bgColor: '#A65B81',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'River 2 Pro',
      src: ['gift3_us.webp', 'gift2_us.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 195,
      allWidth: 450,
      widthPercent: 0.00975,
      nextWidthPercent: 0.01125,
      // 分割线，防止设置错
      stepHeight: 105,
      allHeight: 227,
      heightPercent: 0.00525,
      nextHeightPercent: 0.00525
    }, {
      num: '100,000+',
      number: 100000,
      bgColor: '#CB595C',
      border: '2px solid rgba(255, 255, 255, 0.50)',
      productName: 'Whole-Home Starter Kit',
      src: ['gift4_us.webp', 'gift4_us.png'],
      activeTime: '2023-04-06 17:00:00',
      stepWidth: 225,
      allWidth: 675,
      widthPercent: 0.01125,
      nextWidthPercent: 0.001,
      // 分割线，防止设置错
      stepHeight: 105,
      allHeight: 332,
      heightPercent: 0.00525,
      nextHeightPercent: 17 / 30000
    }]
  }
};
export var activityTime = {
  jp: [new Date('2023/03/15 10:00:00').getTime(), new Date('2023/04/03 23:00:00').getTime()],
  kr: [new Date('2023/03/17 11:00:00').getTime(), new Date('2023/04/10 23:00:00').getTime()],
  za: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/16 20:00:00').getTime()],
  au: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/04/01 11:00:00').getTime()],
  es: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/27 15:00:00').getTime()],
  eu: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/27 15:00:00').getTime()],
  uk: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/27 15:00:00').getTime()],
  it: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/27 15:00:00').getTime()],
  fr: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/27 15:00:00').getTime()],
  de: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/03/27 15:00:00').getTime()],
  us: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/04/03 19:00:00').getTime()],
  ca: [new Date('2023/03/16 11:00:00').getTime(), new Date('2023/04/03 19:00:00').getTime()]
};
export var endTime = {
  jp: new Date('2023/04/03 23:00:00').getTime(),
  kr: new Date('2023/04/10 22:59:59').getTime(),
  za: new Date('2023/04/17 06:00:00').getTime(),
  au: new Date('2023/04/30 10:00:00').getTime(),
  es: new Date('2023/04/10 15:00:00').getTime(),
  eu: new Date('2023/04/10 15:00:00').getTime(),
  uk: new Date('2023/04/10 15:00:00').getTime(),
  it: new Date('2023/04/10 15:00:00').getTime(),
  fr: new Date('2023/04/10 15:00:00').getTime(),
  de: new Date('2023/04/10 15:00:00').getTime(),
  us: new Date('2023/04/10 15:00:00').getTime(),
  ca: new Date('2023/04/10 15:00:00').getTime()
};
export var svgMapPc = {
  jp: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowjapan/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/ecoflowjapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.jp@ecoflow.com'
  }],
  kr: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow_korea/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h25.714v15.905H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(7.143 16.952)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M20.053 7.205c.06-.441.09-.891.09-1.348V2.113h.901c1.41 0 2.552 1.14 2.552 2.546a2.549 2.549 0 0 1-2.552 2.546h-.99zM0 5.857c0 5.549 4.51 10.048 10.072 10.048 4.343 0 8.044-2.743 9.458-6.587h1.514c2.58 0 4.67-2.086 4.67-4.659A4.665 4.665 0 0 0 21.044 0H0v5.857z' fill='%23555' mask='url(%23b)'/%3E%3C/g%3E%3Cpath d='M11.349 13.841H18.928c3.709 0 6.715-2.999 6.715-6.698h-7.58c-3.708 0-6.714 2.999-6.714 6.698' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'https://cafe.naver.com/ecoflowkr'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  za: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/ecoflowsouthafrica'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'support.za@ecoflow.com'
  }],
  uk: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  de: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow.deutschland/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  it: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  es: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  au: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  eu: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  us: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow_korea/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  ca: [{
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.183 7.144c1.87.006 3.237.024 4.098.056 2.334.115 4.142.813 5.424 2.095 1.282 1.282 1.98 3.09 2.095 5.424.036.976.055 2.6.057 4.873V20c0 2.487-.019 4.247-.057 5.28-.115 2.335-.813 4.143-2.095 5.425-1.282 1.282-3.09 1.96-5.424 2.037-.976.073-2.6.11-4.873.115H20c-2.487 0-4.247-.038-5.28-.115-2.335-.114-4.133-.803-5.396-2.066-.497-.46-.9-.995-1.205-1.607a8.12 8.12 0 0 1-.66-1.78c-.134-.573-.201-1.243-.201-2.008-.073-.976-.11-2.6-.115-4.873V20c0-2.487.038-4.267.115-5.338.114-2.296.803-4.075 2.066-5.338 1.263-1.301 3.061-2.009 5.395-2.124.861-.032 2.227-.05 4.098-.056h2.366zM20 13.4c-1.837 0-3.406.65-4.707 1.952C14.031 16.614 13.4 18.163 13.4 20c0 1.837.641 3.396 1.923 4.678S18.163 26.6 20 26.6c1.837 0 3.396-.641 4.678-1.923S26.6 21.837 26.6 20c0-1.837-.641-3.396-1.923-4.678S21.837 13.4 20 13.4zm0 2.296c1.186 0 2.2.421 3.042 1.263.842.842 1.263 1.856 1.263 3.042 0 1.186-.421 2.2-1.263 3.042-.842.842-1.856 1.263-3.042 1.263-1.186 0-2.2-.421-3.042-1.263-.842-.842-1.263-1.856-1.263-3.042 0-1.186.421-2.2 1.263-3.042.842-.842 1.856-1.263 3.042-1.263zm6.888-4.075c-.421 0-.785.143-1.09.43-.307.287-.46.641-.46 1.062 0 .421.153.785.46 1.09.305.307.669.46 1.09.46.42 0 .775-.153 1.062-.46.287-.305.43-.669.43-1.09 0-.42-.153-.765-.46-1.033a1.31 1.31 0 0 0-1.032-.46z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow_korea/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30.177 15.04c.056.213.084.427.084.64 0 3.627-1.368 6.92-4.105 9.88C23.42 28.52 19.763 30 15.184 30c-2.904 0-5.584-.747-8.041-2.24.39.053.81.08 1.256.08 2.401 0 4.58-.72 6.534-2.16-1.173-.053-2.206-.4-3.1-1.04-.893-.64-1.507-1.467-1.842-2.48.335.053.67.08 1.005.08a6.87 6.87 0 0 0 1.424-.16c-1.229-.267-2.248-.853-3.058-1.76-.81-.907-1.214-1.973-1.214-3.2v-.08c.726.427 1.536.64 2.429.64-1.62-1.013-2.429-2.4-2.429-4.16 0-.907.251-1.76.754-2.56 2.792 3.307 6.421 5.067 10.889 5.28a4.168 4.168 0 0 1-.168-1.2c0-1.387.517-2.573 1.55-3.56C22.206 10.493 23.448 10 24.9 10c1.563 0 2.848.533 3.853 1.6a9.969 9.969 0 0 0 3.35-1.2 4.801 4.801 0 0 1-2.261 2.8 10.542 10.542 0 0 0 3.015-.8 11.177 11.177 0 0 1-2.68 2.64z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.08 11.612h-4.025c-.257 0-.496.148-.716.442-.22.294-.331.644-.331 1.048v2.98h5.071l-.716 4.194h-4.355v12.581h-4.796V20.276h-4.355v-4.194h4.355V13.6c0-1.766.551-3.283 1.654-4.552 1.102-1.27 2.499-1.904 4.19-1.904h4.023v4.47z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h40v40H0z'/%3E%3Cpath d='M7.143 14.514l11.517 6.349c.42.231.88.347 1.34.347.46 0 .92-.116 1.34-.347l11.517-6.342v14.567c0 1.29-1.032 2.34-2.301 2.34H9.444c-1.269 0-2.301-1.05-2.301-2.34V14.514zm23.413-5.228c1.269 0 2.301 1.05 2.301 2.34v.407L20.61 18.777c-.382.21-.837.21-1.219 0L7.143 12.025v-.399c0-1.29 1.032-2.34 2.301-2.34h21.112z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }]
};
export var svgMapH5 = {
  jp: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowjapan/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/ecoflowjapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.jp@ecoflow.com'
  }],
  kr: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow_korea/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h20.571v12.724H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(5.782 13.562)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M16.043 5.764c.047-.353.072-.713.072-1.079V1.691h.72a2.04 2.04 0 0 1 2.042 2.036 2.04 2.04 0 0 1-2.042 2.037h-.792zM0 4.685c0 4.44 3.607 8.039 8.057 8.039a8.06 8.06 0 0 0 7.567-5.27h1.211a3.732 3.732 0 0 0 3.736-3.727A3.732 3.732 0 0 0 16.835 0H0v4.685z' fill='%23555' mask='url(%23b)'/%3E%3C/g%3E%3Cpath d='M9.147 11.073H15.21c2.967 0 5.372-2.399 5.372-5.359h-6.064a5.365 5.365 0 0 0-5.371 5.36' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'https://cafe.naver.com/ecoflowkr'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  za: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/ecoflowsouthafrica'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'support.za@ecoflow.com'
  }],
  uk: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  de: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow.deutschland/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  it: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  es: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  au: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  eu: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflowtech/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  us: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow_korea/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }],
  ca: [{
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.267 5.76c1.871.092 3.32.65 4.349 1.676 1.027 1.026 1.587 2.472 1.68 4.34.026.723.041 1.891.044 3.505v1.438a112.84 112.84 0 0 1-.045 3.505c-.092 1.868-.652 3.314-1.68 4.34-1.027 1.025-2.477 1.569-4.348 1.63-.776.057-2.065.088-3.866.091h-.367c-1.994 0-3.405-.03-4.234-.091-1.87-.092-3.313-.643-4.325-1.653a4.432 4.432 0 0 1-.966-1.286 6.488 6.488 0 0 1-.53-1.423 7.115 7.115 0 0 1-.16-1.608c-.058-.774-.089-2.06-.092-3.858V16c0-1.99.03-3.413.091-4.27.092-1.837.645-3.26 1.657-4.27 1.012-1.042 2.454-1.608 4.325-1.7.673-.025 1.731-.04 3.174-.044l1.78-.001c1.617.003 2.788.018 3.513.045zm-4.233 4.96c-1.473 0-2.73.52-3.773 1.56-1.013 1.01-1.519 2.25-1.519 3.72 0 1.47.514 2.717 1.542 3.742 1.027 1.026 2.277 1.539 3.75 1.539 1.472 0 2.722-.513 3.75-1.539 1.028-1.025 1.542-2.273 1.542-3.742 0-1.47-.514-2.717-1.542-3.742-1.028-1.026-2.278-1.539-3.75-1.539zm0 1.836c.95 0 1.764.337 2.439 1.01A3.314 3.314 0 0 1 19.485 16c0 .949-.338 1.76-1.012 2.434a3.328 3.328 0 0 1-2.44 1.01 3.328 3.328 0 0 1-2.438-1.01A3.314 3.314 0 0 1 12.583 16c0-.949.337-1.76 1.012-2.434a3.328 3.328 0 0 1 2.439-1.01zm5.522-3.26c-.338 0-.63.115-.875.344-.245.23-.368.513-.368.85 0 .337.123.627.368.872.246.245.537.368.875.368.337 0 .62-.123.85-.368a1.23 1.23 0 0 0 .346-.872c0-.337-.123-.612-.368-.827a1.051 1.051 0 0 0-.828-.367z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.instagram.com/ecoflow_korea/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.104 12.032c.045.17.067.341.067.512 0 2.901-1.097 5.536-3.29 7.904C19.687 22.816 16.755 24 13.084 24c-2.328 0-4.477-.597-6.446-1.792.313.043.649.064 1.007.064 1.925 0 3.67-.576 5.238-1.728-.94-.043-1.769-.32-2.485-.832a3.895 3.895 0 0 1-1.477-1.984 5.128 5.128 0 0 0 1.947-.064c-.985-.213-1.802-.683-2.45-1.408a3.715 3.715 0 0 1-.974-2.56v-.064a3.777 3.777 0 0 0 1.947.512c-1.298-.81-1.947-1.92-1.947-3.328 0-.725.201-1.408.604-2.048 2.238 2.645 5.148 4.053 8.73 4.224a3.328 3.328 0 0 1-.135-.96c0-1.11.414-2.059 1.242-2.848C18.713 8.394 19.71 8 20.873 8c1.254 0 2.283.427 3.09 1.28.984-.17 1.88-.49 2.685-.96a3.843 3.843 0 0 1-1.813 2.24 8.466 8.466 0 0 0 2.418-.64 8.951 8.951 0 0 1-2.15 2.112z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://twitter.com/EcoflowJapan'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.532 9.29h-3.226c-.206 0-.398.118-.575.353a1.357 1.357 0 0 0-.265.839v2.384h4.066l-.575 3.355h-3.49v10.065H14.62V16.22h-3.49v-3.355h3.49v-1.987c0-1.412.442-2.626 1.326-3.642.884-1.015 2.004-1.523 3.359-1.523h3.226V9.29z' fill='%23555' fill-rule='evenodd'/%3E%3C/svg%3E",
    link: 'https://www.facebook.com/EcoFlow-KR-100921972559202/'
  }, {
    svg: "data:image/svg+xml,%3Csvg width='33' height='32' viewBox='0 0 33 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M.932 0H33v32H.932z'/%3E%3Cpath d='M6.659 11.61l9.233 5.08c.336.185.705.278 1.074.278.37 0 .738-.093 1.075-.278l9.233-5.073V23.27c0 1.032-.828 1.873-1.845 1.873H8.504c-1.018 0-1.845-.84-1.845-1.873V11.61zm18.77-4.181c1.017 0 1.845.84 1.845 1.872v.325l-9.82 5.395c-.306.168-.67.168-.977 0L6.66 9.62V9.3c0-1.032.827-1.872 1.845-1.872h16.925z' fill='%23555'/%3E%3C/g%3E%3C/svg%3E",
    link: 'hello.kr@ecoflow.com'
  }]
};
export var scrollCardMap = {
  jp: [{
    subTitle: '究極の特典',
    title: 'エコポイントプログラムは\nさまざまな特典がもらえる\nEcoFlowの会員限定サービスです',
    desc: ['1.エコポイントが通常の2倍にアップ（不定期）', '2.新製品専用のクーポンをプレゼント', '3.お誕生月はエコポイントが通常の2倍にアップ', '4.バースデークーポンをプレゼント', '5.ポイント交換（クーポン、EcoFlowグッズ、QUOカードPay）'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'ベストなサービス',
    title: '安心できるご購入と保証サービス',
    desc: ['1.送料無料', '2.チャットアプリでのサポート'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: '最新情報を配信',
    title: '最新の話題をいち早く\nお届けします',
    desc: ['1.新製品の体験', '2.オフラインイベントの参加チャンス', '3.会員限定キャンペーン'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: '今すぐ登録する',
    btnLink: 'https://www.ecoflow.com/jp/login?redirect=https://www.ecoflow.com/jp/ecocredits-day'
  }],
  kr: [{
    subTitle: '특별한 혜택',
    title: '에코 포인트 제도와 함께 특별한\n회원 혜택을 누려보세요',
    desc: ['1. 단독 할인', '2. 쿠폰 및 사은품 교환'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: '믿을 수 있는 구매',
    title: 'A/S 서비스도 에코플로우가\n책임집니다',
    desc: ['1. 무료 배송', '2. 보증 기간 등록'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: '최신 소식 업데이트',
    title: '이벤트, 세일 프로모션 등 \n다양한 에코플로우 소식이 \n찾아옵니다',
    desc: ['1. 가장 먼저 에코플로우의 최신 소식을 받아보세요', '2. 신제품 사전 예약 이벤트', '3. 회원 대상 특별 프로모션'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: '회원 가입하기',
    btnLink: 'https://www.ecoflow.com/kr/register?redirect=https://www.ecoflow.com/kr/ecocredits-day'
  }],
  za: [{
    subTitle: 'The Ultimate Benefits ',
    title: 'Earn EcoCredits and exchange for exclusive rewards every time you shop',
    desc: ['- Earn EcoCredits for every purchase', '- Redeem EcoCredits for discounts', '- Redeem EcoCredits for gifts', '- Participate in Member-exclusive events'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }],
  uk: [{
    subTitle: 'Ultimate Benefits',
    title: 'Earn EcoCredits and exchange for exclusive rewards every time you shop',
    desc: ['- Earn EcoCredits for every purchase', '- Redeem EcoCredits for discounts', '- Redeem EcoCredits for gifts'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'Excellent Service',
    title: 'Quality shopping experience',
    desc: ['- Dependable warranty services', '- Convenient warranty registration', '- Support within 24 hours (chat & email)'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'Latest Updates',
    title: 'Be the first to get EcoFlow news and product information',
    desc: ['- Early access to new products and\nproduct testing', "- Member's offline events", '- Community discussions'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'Join our community',
    btnLink: 'https://www.facebook.com/ecoflowtech'
  }],
  de: [{
    subTitle: 'Ultimative Vorteile',
    title: 'Verdienen Sie EcoCredits und tauschen Sie sie bei jedem Einkauf gegen exklusive Prämien ein',
    desc: ['- Verdienen Sie EcoCredits für jeden Einkauf', '- Lösen Sie EcoCredits für Rabatte ein', '- Lösen Sie EcoCredits für Geschenke ein'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'Ausgezeichneter Service',
    title: 'Hochwertiges Einkaufserlebnis',
    desc: ['- Zuverlässige Garantieleistungen ', '- Bequeme Garantieregistrierung', '- Support innerhalb von 24 Stunden\n(Chat und E-Mail)'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'Neueste Updates',
    title: 'Seien Sie der Erste, der EcoFlow-Nachrichten und Produktinformationen erhält',
    desc: ['- Früher Zugang zu neuen Produkten und Produkttests', '- Offline-Veranstaltungen für Mitglieder', '- Community-Gespräche'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'TRETEN SIE DER GEMEINSCHAFT BEI',
    btnLink: 'https://www.facebook.com/EcoFlowDeutschland'
  }],
  fr: [{
    subTitle: 'Avantages ultimes',
    title: 'Gagnez des EcoCredits et échangez-les contre des récompenses exclusives à chaque achat.',
    desc: ['- Gagnez des EcoCredits pour chaque achat', '- Échangez des EcoCredits contre des réductions', '- Échangez des EcoCredits contre des cadeaux'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'Excellent service',
    title: 'Expérience d’achat de qualité',
    desc: ['- Services de garantie fiables', '- Enregistrement de la garantie pratique', '- Assistance dans les 24 heures\n(chat et e-mail)'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'Dernières actualités',
    title: "Soyez les premiers à recevoir les actualités et les nouveautés produits d'EcoFlow",
    desc: ['- Accès anticipé aux nouveaux produits et aux tests de produits', '- Événements hors ligne pour les membres', '- Discussions communautaires'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'REJOIGNEZ LA COMMUNAUTÉ',
    btnLink: 'https://www.facebook.com/groups/ecoflowfrancophone'
  }],
  it: [{
    subTitle: 'Vantaggi eccezionali',
    title: 'Guadagna EcoCredit e scambiali con premi esclusivi ogni volta che fai acquisti',
    desc: ['- Guadagna EcoCredit con ogni acquisto', '- Riscatta EcoCredit in cambio di sconti', '- Riscatta EcoCredit in cambio di omaggi'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'Servizio eccellente',
    title: 'Esperienza di shopping di qualità',
    desc: ['- Assistenza affidabile in garanzia', '- Comoda registrazione della garanzia', '- Assistenza entro 24 ore (chat e e-mail)'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'Ultimi aggiornamenti',
    title: 'Scopri le novità e le informazioni sui prodotti EcoFlow in anteprima',
    desc: ['- Accesso anticipato a nuovi prodotti e test dei prodotti', '- Eventi offline per i membri', '- Discussioni con la community'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'UNISCITI ALLA COMUNITÀ',
    btnLink: 'https://www.facebook.com/ecoflowtech'
  }],
  es: [{
    subTitle: 'Máximas ventajas',
    title: 'Obtener EcoCredits y canjearlos por premios exclusivos cada vez que compres un producto',
    desc: ['- Obtener EcoCredits en cada compra', '- Canjear los EcoCredits para obtener descuentos', '- Canjear los EcoCredits por regalos'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'Excelente servicio',
    title: 'Experiencia de compra de calidad',
    desc: ['- Servicios de garantía fiables ', '- Registro de garantía cómodo y sencillo', '- Servicio de atención al cliente las 24 horas (chat y correo electrónico)'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'Últimas novedades',
    title: 'Sé el primero en conocer las últimas novedades de Ecoflow e información sobre los productos',
    desc: ['- Acceso anticipado a nuevos productos y a pruebas de los productos', '- Eventos fuera de línea para miembross', '- Foros y debates de la comunidad'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'UNIRSE A LA COMUNIDAD',
    btnLink: 'https://www.facebook.com/ecoflowtech'
  }],
  au: [{
    subTitle: 'The Ultimate Benefits ',
    title: 'Earn EcoCredits and exchange for exclusive rewards every time you shop',
    desc: ['- Earn EcoCredits for every purchase', '- Redeem EcoCredits for discounts', '- Redeem EcoCredits for gifts', '- Participate in Member-exclusive events'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }],
  eu: [{
    subTitle: 'Ultimate Benefits',
    title: 'Earn EcoCredits and exchange for exclusive rewards every time you shop',
    desc: ['- Earn EcoCredits for every purchase', '- Redeem EcoCredits for discounts', '- Redeem EcoCredits for gifts'],
    src: ['scroll_card1.webp', 'scroll_card1.png']
  }, {
    subTitle: 'Excellent Service',
    title: 'Quality shopping experience',
    desc: ['- Dependable warranty services', '- Convenient warranty registration', '- Support within 24 hours (chat & email)'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'Latest Updates',
    title: 'Be the first to get EcoFlow news and product information',
    desc: ['- Early access to new products and\nproduct testing', "- Member's offline events", '- Community discussions'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'Join our community',
    btnLink: 'https://www.facebook.com/ecoflowtech'
  }],
  us: [{
    subTitle: 'The Ultimate Benefits',
    title: 'Earn EcoCredits and exchange for exclusive rewards every time you shop',
    desc: ['- Exclusive discounts', '- Referral program', '- $1 spent = 1 EcoCredit, redeem EcoCredits for coupons and gifts'],
    src: ['scroll_card1.webp', 'scroll_card1.png'],
    btnText: 'Shop on EcoFlow.store',
    btnLink: "https://us.ecoflow.com/collections/portable-power-stations",
    naGtm: true
  }, {
    subTitle: 'The Excellent Service',
    title: 'Quality shopping experience',
    desc: ['- Warranty registration', '- 24/7 support (chat and email)', '- Trade-in program'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'The Latest Updates',
    title: 'Be the first to get EcoFlow news and product information',
    desc: ['- Early access to new products', '- Offline events', '- Community discussions'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'Join our community',
    btnLink: 'https://www.facebook.com/groups/ecoflowclub'
  }],
  ca: [{
    subTitle: 'The Ultimate Benefits',
    title: 'Earn EcoCredits and exchange for exclusive rewards every time you shop',
    desc: ['- Exclusive discounts', '- Referral program', '- $1 spent = 1 EcoCredit, redeem EcoCredits for coupons and gifts'],
    src: ['scroll_card1.webp', 'scroll_card1.png'],
    btnText: 'Shop on EcoFlow.store',
    btnLink: "https://ca.ecoflow.com/collections/portable-power-stations",
    naGtm: true
  }, {
    subTitle: 'The Excellent Service',
    title: 'Quality shopping experience',
    desc: ['- Warranty registration', '- 24/7 support (chat and email)', '- Trade-in program'],
    src: ['scroll_card2.webp', 'scroll_card2.png']
  }, {
    subTitle: 'The Latest Updates',
    title: 'Be the first to get EcoFlow news and product information',
    desc: ['- Early access to new products', '- Offline events', '- Community discussions'],
    src: ['scroll_card3.webp', 'scroll_card3.png'],
    btnText: 'Join our community',
    btnLink: 'https://www.facebook.com/groups/ecoflowclub'
  }]
};
export var specialsMap = {
  jp: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'エコポイントをクーポンに交換する。\n1エコポイント＝7円相当のクーポンとなります'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'エコポイントをスペシャルギフトに交換する'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'エコポイントを会員特典ギフトに交換する'
  }, {
    src: ['specials4.webp', 'specials4.png'],
    title: 'エコポイントを会員限定イベント参加権に交換する'
  }],
  kr: [{
    src: ['specials2.webp', 'specials2.png'],
    title: '1 에코 포인트 = 70원'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: '사은품으로 교환'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: '회원 단독 제공 제품 구매'
  }, {
    src: ['specials4.webp', 'specials4.png'],
    title: '회원 단독 이벤트 참여'
  }],
  za: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Redeem for coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Redeem for gifts'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Reddem for special products'
  }, {
    src: ['specials4.webp', 'specials4.png'],
    title: 'Participate in Member-exclusive events'
  }],
  uk: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Redeem for coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Redeem for gifts'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Redeem for invitations to fan events'
  }],
  de: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Einlösen für Gutscheine'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Einlösen für Geschenke'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Einlösen für Einladungen zu Fan-Events'
  }],
  fr: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Échangez-les contre des coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Échangez-les contre des cadeaux'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Échangez-les contre des invitations à des événements pour les fans'
  }],
  it: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Riscattali in cambio di coupon'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Riscattali in cambio di omaggi'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Riscattali in cambio di inviti agli eventi per i fan'
  }],
  es: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Canjear por cupones'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Canjear por regalos'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Canjear por invitaciones a eventos para seguidores'
  }],
  au: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Redeem for coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Redeem for gifts'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Redeem EcoCredits for special products'
  }, {
    src: ['specials4.webp', 'specials4.png'],
    title: 'Participate in Member-exclusive events'
  }],
  eu: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Redeem for coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Redeem for gifts'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Redeem for invitations to fan events'
  }],
  us: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Redeem for coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Redeem for gifts'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Redeem for invitations to fan events'
  }],
  ca: [{
    src: ['specials2.webp', 'specials2.png'],
    title: 'Redeem for coupons'
  }, {
    src: ['specials1.webp', 'specials1.png'],
    title: 'Redeem for gifts'
  }, {
    src: ['specials3.webp', 'specials3.png'],
    title: 'Redeem for invitations to fan events'
  }]
};
export var cardMap = {
  jp: [{
    text: '会員限定特典',
    src: ['card1.webp', 'card1.png']
  }, {
    text: '会員限定クーポンGET',
    src: ['card2.webp', 'card2.png']
  }, {
    text: 'ポイントを会員限定イベント参加権に交換',
    src: ['card3.webp', 'card3.png']
  }, {
    text: 'ポイントを\nQUOカードPayに交換',
    src: ['card4.webp', 'card4.png']
  }],
  kr: [{
    text: '회원 단독 혜택',
    src: ['card1.webp', 'card1.png']
  }, {
    text: '특별 할인 쿠폰 증정',
    src: ['card2.webp', 'card2.png']
  }, {
    text: '에코플로우 굿즈 증정',
    src: ['card3_kr.webp', 'card3_kr.png']
  }]
};
export var topProductMap = {
  jp: [[{
    percent: '30% OFF',
    name: 'DELTA Pro + 専用エクストラバッテリー *1 + 400Wソーラーパネル',
    desc: '8,116ポイント',
    limitPrice: '608,720',
    price: '869,600',
    btnName: 'エクストラバッテリー1台',
    img: ['product1_jp.webp', 'product1_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-portable-power-station-smart-extra-battery-400w-solar-panel?variant=42890017439905',
    productId: '42890017439905'
  }, {
    percent: '30% OFF',
    name: 'DELTA Pro + 専用エクストラバッテリー *2 + 400Wソーラーパネル',
    desc: '11,104ポイント',
    limitPrice: '832,790',
    price: '1,189,700',
    btnName: 'エクストラバッテリー2台',
    img: ['product2_jp.webp', 'product2_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-portable-power-station-smart-extra-battery-400w-solar-panel?variant=42890017472673',
    productId: '42890017472673'
  }], [{
    percent: '30% OFF',
    name: 'DELTA Max 2000+400Wソーラーパネル',
    desc: '3,336ポイント',
    limitPrice: '250,210',
    price: '357,440',
    btnName: '400W',
    img: ['product3_jp.webp', 'product3_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-max-2000-solar-generator-400w-solar-panel?variant=42188872253601',
    productId: '42188872253601'
  }, {
    percent: '30% OFF',
    name: 'DELTA Max 2000+220W両面受光型ソーラーパネル',
    desc: '2,818ポイント',
    limitPrice: '211,370',
    price: '301,960',
    btnName: '220W両面受光型',
    img: ['product4_jp.webp', 'product4_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-max-2000-solar-generator-220w-solar-panel?variant=41819132166305',
    productId: '41819132166305'
  }]]
};
export var productItemMap = {
  jp: [{
    percent: '30% OFF',
    name: 'DELTA Pro + スマート発電機 + 400Wソーラーパネル',
    desc: '6,573ポイント',
    limitPrice: '492,940',
    price: '704,200',
    img: ['product_item1_jp.webp', 'product_item1_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-portable-power-station-400w-solar-panel-smart-generator',
    productId: '42881870856353'
  }, {
    percent: '30% OFF',
    name: 'DELTA Pro + \n400Wソーラーパネル',
    desc: '5,129ポイント',
    limitPrice: '384,650',
    price: '549,500',
    img: ['product_item2_jp.webp', 'product_item2_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-solar-generator-400w-solar-panel?variant=41869118144673',
    productId: '41869118144673'
  }, {
    percent: '30% OFF',
    name: 'DELTA Pro + 専用エクストラバッテリー',
    desc: '6,971ポイント',
    limitPrice: '522,830',
    price: '746,900',
    img: ['product_item3_jp.webp', 'product_item3_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-smart-extra-battery-bundle?variant=41653573222561',
    productId: '41653573222561'
  }, {
    percent: '30% OFF',
    name: 'DELTA 2 +220W両面受光型ソーラーパネル',
    desc: '1,932ポイント',
    limitPrice: '144,890',
    price: '206,990',
    img: ['product_item4_jp.webp', 'product_item4_jp.png'],
    isHot: true,
    isLimit: true,
    link: 'https://jp.ecoflow.com/products/delta-2-solar-generator-220w-solar-panel?variant=42416379625633',
    productId: '42416379625633'
  }, {
    percent: '30% OFF',
    name: 'DELTA Pro',
    desc: '4,107ポイント',
    limitPrice: '308,000',
    price: '440,000',
    img: ['product_item5_jp.webp', 'product_item5_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-portable-power-station',
    productId: '40357958713505'
  }, {
    percent: '30% OFF',
    nameDesc: 'DELTA Max専用カバーをプレゼント！',
    h5NameDesc: 'DELTA Max専用カバーを\nプレゼント！',
    name: 'DELTA Max 2000',
    desc: '2,259ポイント',
    limitPrice: '169,400',
    price: '242,000',
    img: ['product_item6_jp.webp', 'product_item6_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-max?variant=42894377058465',
    productId: '42894377058465'
  }, {
    percent: '20% OFF',
    name: 'DELTA Pro 専用エクストラバッテリー',
    desc: '3,520ポイント',
    limitPrice: '264,000',
    price: '330,000',
    img: ['product_item7_jp.webp', 'product_item7_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-pro-smart-extra-battery',
    productId: '41256639266977'
  }, {
    percent: '20% OFF',
    name: 'DELTA Max 専用エクストラバッテリー',
    desc: '1,596ポイント',
    limitPrice: '119,680',
    price: '149,600',
    img: ['product_item8_jp.webp', 'product_item8_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-max-extra-battery',
    productId: '41173847834785'
  }, {
    percent: '20% OFF',
    name: 'DELTA 2 専用エクストラバッテリー',
    desc: '1,173ポイント',
    limitPrice: '88,000',
    price: '110,000',
    img: ['product_item9_jp.webp', 'product_item9_jp.png'],
    link: 'https://jp.ecoflow.com/products/delta-2-extra-battery?_pos=2&_sid=40329c9de&_ss=r',
    productId: '42399221612705'
  }, {
    percent: '20% OFF',
    name: '400Wソーラーパネル',
    desc: '1,349ポイント',
    limitPrice: '101,200',
    price: '126,500',
    img: ['product_item10_jp.webp', 'product_item10_jp.png'],
    link: 'https://jp.ecoflow.com/products/400w-solar-panel',
    productId: '41282474836129'
  }, {
    percent: '20% OFF',
    name: '220W両面受光型ソーラーパネル',
    desc: '739ポイント',
    limitPrice: '55,440',
    price: '69,300',
    img: ['product_item11_jp.webp', 'product_item11_jp.png'],
    link: 'https://jp.ecoflow.com/products/220w-solar-panel',
    productId: '41660573876385'
  }, {
    percent: '20% OFF',
    name: '160Wソーラーパネル',
    desc: '458ポイント',
    limitPrice: '34,320',
    price: '42,900',
    img: ['product_item12_jp.webp', 'product_item12_jp.png'],
    link: 'https://jp.ecoflow.com/products/160w-solar-panel',
    productId: '39255422009505'
  }]
};
export var productInfoMap = {
  us: [{
    productName: 'Outdoor Kit',
    info: ['• 100 winners', '• Includes Water Bottle & Torch']
  }, {
    productName: '10% Off Coupon',
    info: ['• 50 winners', '• Available for all products excluding flash sale products and new products (RIVER 2 Pro / Glacier / WAVE 2/ Blade)', '• Only valid between March 27 - April 20']
  }, {
    productName: 'RIVER 2 Pro (Newest Product)',
    info: ['• 5 winners', '• Charge 0-100% in only 70 mins.', '• Safe and reliable for 10 years of use.']
  }, {
    productName: 'Whole-Home Starter Kit',
    info: ['• 1 winner', '• 3600W | 3.6 kWh | 120V', '• Up to 1-day of essential power']
  }]
};
export var fixedLoginBtn = {
  us: {
    btnLink: 'https://www.ecoflow.com/us/register?redirect=https://www.ecoflow.com/us/my',
    svgUrl: "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip57_720)' stroke='%23FFF' stroke-width='2' stroke-linejoin='round'%3E%3Cpath d='M13 6.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0zM18 14.5v6m-3-3h6'/%3E%3Cpath d='M13.5 14H9.4c-2.24 0-3.36 0-4.216.436a4.005 4.005 0 0 0-1.748 1.748C3 17.04 3 18.16 3 20.4v.6h10.5' stroke-linecap='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip57_720'%3E%3Cpath id='svg' fill='%23fff' d='M0 0h24v24H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
  },
  ca: {
    btnLink: 'https://www.ecoflow.com/ca/register?redirect=https://www.ecoflow.com/ca/my',
    svgUrl: "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip57_720)' stroke='%23FFF' stroke-width='2' stroke-linejoin='round'%3E%3Cpath d='M13 6.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0zM18 14.5v6m-3-3h6'/%3E%3Cpath d='M13.5 14H9.4c-2.24 0-3.36 0-4.216.436a4.005 4.005 0 0 0-1.748 1.748C3 17.04 3 18.16 3 20.4v.6h10.5' stroke-linecap='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip57_720'%3E%3Cpath id='svg' fill='%23fff' d='M0 0h24v24H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
  }
};
export var fixedLoginBtnH5 = {
  us: {
    btnLink: 'https://www.ecoflow.com/us/register?redirect=https://www.ecoflow.com/us/my',
    svgUrl: "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip57_726)' stroke='%23FFF' stroke-width='1.667' stroke-linejoin='round'%3E%3Cpath d='M10.833 5.417a2.916 2.916 0 1 0-5.833 0 2.916 2.916 0 0 0 5.833 0zM15 12.083v5m-2.5-2.5h5'/%3E%3Cpath d='M11.25 11.667H7.833c-1.866 0-2.8 0-3.513.363-.628.32-1.137.83-1.457 1.457C2.5 14.2 2.5 15.133 2.5 17v.5h8.75' stroke-linecap='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip57_726'%3E%3Cpath id='svg' fill='%23fff' d='M0 0h20v20H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
  },
  ca: {
    btnLink: 'https://www.ecoflow.com/ca/register?redirect=https://www.ecoflow.com/ca/my',
    svgUrl: "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip57_726)' stroke='%23FFF' stroke-width='1.667' stroke-linejoin='round'%3E%3Cpath d='M10.833 5.417a2.916 2.916 0 1 0-5.833 0 2.916 2.916 0 0 0 5.833 0zM15 12.083v5m-2.5-2.5h5'/%3E%3Cpath d='M11.25 11.667H7.833c-1.866 0-2.8 0-3.513.363-.628.32-1.137.83-1.457 1.457C2.5 14.2 2.5 15.133 2.5 17v.5h8.75' stroke-linecap='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip57_726'%3E%3Cpath id='svg' fill='%23fff' d='M0 0h20v20H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
  }
};
export var translateArr = function translateArr(baseArr, n) {
  var len = baseArr.length;
  var lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
  var res = [];
  for (var _i = 0; _i < lineNum; _i++) {
    var _temp2 = baseArr.slice(_i * n, _i * n + n);
    res.push(_temp2);
  }
  return res;
};